import type { ButtonHTMLAttributes, FC, ReactNode } from "react";
import { Icon } from "../../../components/icon";
import { ClassNames } from "../../../modules/utils";
import "./createRequestButton.scss";

type Props = ButtonHTMLAttributes<HTMLButtonElement> & {
  label?: string;
  prefixIcon?: ReactNode;
  className?: string;
};

const CreateRequestButton: FC<Props> = ({ label, prefixIcon, className, ...props }) => {
  return (
    <button
      type="button"
      className={ClassNames({ "btn create-request-btn": true, [className as string]: !!className })}
      {...props}
    >
      {prefixIcon ?? <Icon.Plus />}
      {label ?? "Tạo yêu cầu"}
    </button>
  );
};

export default CreateRequestButton;
